import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { EstimateTag } from '../../models/estimate/EstimateViewModel';

interface EstimateTagBadgeProps {
  tag: EstimateTag;
  isCollapsable: boolean;
  removeTag?: (EstimateTag: EstimateTag) => Promise<void>;
}

export default function EstimateTagBadge({
  tag,
  isCollapsable,
  removeTag,
}: EstimateTagBadgeProps) {
  const [showTag, setShowTag] = useState(false);

  const getInitials = () => {
    const initials = tag.name.match(/\b\w/g) || [];
    return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
  };

  return (
    <div
      className={`badge d-flex gap-1 align-items-center ${
        !tag.color ? 'text-bg-light text-black border' : ''
      }`}
      style={{
        backgroundColor: tag.color ? `#${tag.color}` : '',
        maxWidth: isCollapsable ? '10rem' : '20rem',
      }}
      role='button'
      aria-hidden='true'
      onClick={() => setShowTag(!showTag)}
      title={tag.name}
    >
      {isCollapsable ? (
        <span className='text-truncate text-uppercase'>
          {showTag ? tag.name : getInitials()}
        </span>
      ) : (
        <>
          <span className='text-truncate text-uppercase'>{tag.name}</span>
          {removeTag && (
            <FaTimes
              size={15}
              cursor='pointer'
              onClick={() => removeTag(tag)}
            />
          )}
        </>
      )}
    </div>
  );
}
